<div
  [class.medium-button]="size === 'medium'"
  [class.small-button]="size === 'small'"
  [class.large-button]="size === 'large'"
  [class.secondary]="type === 'secondary'"
  [class.warning]="type === 'warning'"
  [class.disable]="disabled"
  (click)="handleClick($event)"
>
  <span *ngIf="!isLoading"> <ng-content></ng-content> </span>
  <app-spinner *ngIf="isLoading"></app-spinner>
</div>
